import React, { Component } from 'react';
import { connect } from 'react-redux';
import './index.css';

class Footer extends Component {
  constructor(props) {
    super(props);
    this.state = {
      viewport: {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      }
    }
    this._resize_mixin_callback = this._resize_mixin_callback.bind(this);
  }


  componentDidMount() {
    window.addEventListener('resize', this._resize_mixin_callback);
  }

  _resize_mixin_callback() {
    this.setState({
      viewport: {
        width: document.documentElement.clientWidth,
        height: document.documentElement.clientHeight
      }
    });
  }

  componentWillUnmount() {
    window.removeEventListener('resize', this._resize_mixin_callback);
  }

  getResponsiveStyle() {
    const { viewport } = this.state;
    const { lang } = this.props;
    if (viewport.width > 1450) {
      if (lang === 'fa') { return { topLayerDesc: 'center' } }
      else { return { topLayerDesc: '' } }
    }
    else { return { topLayerDesc: '' } }
  }

  render() {
    const { lang } = this.props;
    //const responsiveStyle = this.getResponsiveStyle();
    return (
      <div className='footer-ft-container'>
        <div className='footer-ft-wrapper-sc'>
          <div id='footer-main-content' className='footer-ft-main-content-sc'>
            <div className='footer-ft-main-content-sc-wrapper'>
              <div style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }} className='footer-ft-main-content-sc-column-dispaly'>
                <h2>{lang === 'fa' ? 'منابع آموزش بورس ویو' : 'Links'}</h2>
                <div className='footer-ft-main-content-sc-icon-wr'>
                  <span>
                    <a className='a-tag-white' href="https://learning.emofid.com/events/" target="_blank" rel="noreferrer">
                      {lang === 'fa' ? 'اطلاع از کلاس های آموزشی آنلاین بورس ویو در کارگزاری مفید' : 'Information on training classes'}
                    </a>
                  </span>
                  <div style={{ marginLeft: lang === 'fa' ? '10px' : '' }} className='bg-red'>
                    <img alt='' src={require('../../../../assets/images/link.svg')} />
                  </div>
                </div>
                <div className='footer-ft-main-content-sc-icon-wr'>
                  <span>
                    <a className='a-tag-white' href="https://learning.emofid.com/what-is-the-bourse-view/" target="_blank" rel="noreferrer">
                      {lang === 'fa' ? 'راهنمای کاربری و آموزش بورس ویو در وبسایت آموزش کارگزاری مفید' : 'User guide and training'}
                    </a>
                  </span>
                  <div style={{ marginLeft: lang === 'fa' ? '10px' : '' }} className='bg-red'>
                    <img alt='' src={require('../../../../assets/images/link.svg')} />
                  </div>
                </div>
                <div
                  style={{ width: '75px', height: '75px' }}>
                  <a
                    referrerPolicy="origin"
                    target="_blank"
                    href="https://trustseal.enamad.ir/?id=73864&amp;Code=0LcN3gbmsccUOoXIQNzF"
                  >
                    <img
                      referrerPolicy="origin"
                      src="https://trustseal.enamad.ir/Content/Images/Star2/81.png?v=5.0.0.3777"
                      alt=""
                      style={{ cursor: 'pointer', width: '75px', height: '75px', marginTop: '8px', backgroundColor: '#fff', borderRadius: '4px' }}
                      id="0LcN3gbmsccUOoXIQNzF"></img>
                  </a>
                </div>
              </div>
              <div style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }} className='footer-ft-main-content-sc-column-dispaly'>
                <h2>{lang === 'fa' ? 'تماس با ما' : 'Reach Us'}</h2>
                <p>{lang === 'fa' ? 'تهران، بلوار آفریقا، نبش دیدار شمالی، ساختمان مفید، طبقه ششم، کد پستی 1589914511'
                  : '6th Floor, Mofid Tower, Africa Blvd, Tehran 1589914511, Iran'}</p>
                <div className='footer-ft-main-content-sc-icon-wr'>
                  <span style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }}>
                    {lang === 'fa' ? 'مرکز تماس و پشتیبانی کارگزاری مفید: 8700-021' : '+98 21 8700'}
                  </span>
                  <div style={{ marginLeft: lang === 'fa' ? '10px' : '' }} className='bg-green'>
                    <img alt='' src={require('../../../../assets/images/phone-call.svg')} />
                  </div>
                </div>
                <div className='footer-ft-main-content-sc-icon-wr'>
                  <span style={{ direction: lang === 'fa' ? 'rtl' : 'ltr' }}>
                    {lang === 'fa' ? 'تماس با واحد فروش: 81903000-021' : 'suport: +98 21 81903000'}
                  </span>
                  <div style={{ marginLeft: lang === 'fa' ? '10px' : '' }} className='bg-green'>
                    <img alt='' src={require('../../../../assets/images/phone-call.svg')} />
                  </div>
                </div>
                <div className='footer-ft-main-content-sc-icon-wr'>
                  <span>{lang === 'fa' ? 'info@pouyafinance.com' : 'info@pouyafinance.com'}</span>
                  <div style={{ marginLeft: lang === 'fa' ? '10px' : '' }} className='bg-red'>
                    <img alt='' src={require('../../../../assets/images/message.svg')} />
                  </div>
                </div>
              </div>
            </div>
            <div className='footer-ft-main-content-sc-wrapper'>
              <div className='footer-ft-main-content-sc-map-image'>
                <iframe src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3237.6239191560576!2d51.414272715261!3d35.76004738017598!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x4c0055d5d36bc42c!2sMofid%20Securities!5e0!3m2!1sen!2sus!4v1628665997917!5m2!1sen!2sus"
                  width="100%" height="100%" style={{ border: '0' }} allowFullScreen="" loading="lazy"></iframe>
              </div>
            </div>
          </div>
          <div id='footer-copy-right' className='footer-ft-copy-right-sc'>
            <div>© BourseView. All Right Reserved</div>
            <div>Made by <a href="http://www.pouyafinance.com">Pouya Finance</a></div>
          </div>
        </div>
      </div>
    );
  }
}

const mapStateToProps = state => ({
  lang: state.request.lang
});

export default connect(mapStateToProps, null)(Footer);
